import { Box } from "@govlaunch/web";
import React from "react";
import { FormattedMessage } from "react-intl";

interface ICollectionCardTotalProps {
  total: number;
}

export default function CollectionCardTotal({ total }: ICollectionCardTotalProps) {
  return (
    <Box
      position="absolute"
      bottom="8px"
      right="8px"
      color="gray.800"
      fontSize={["lg", "sm", "md", "md"]}
      fontWeight={["semibold", "normal", "normal", "normal"]}
    >
      <FormattedMessage defaultMessage="{total} Total" id="fkXl+5" values={{ total }} />
    </Box>
  );
}
